
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface Module {
  id: string;
  title: string;
  description?: string;
}

interface LessonsGridHeaderProps {
  onBack: () => void;
  moduleDetails?: Module | null;
  lessonsCount: number;
}

/**
 * LessonsGridHeader component - displays the header section with back button and module info
 * Shows module title and lesson count when module details are available
 */
export const LessonsGridHeader = ({ onBack, moduleDetails, lessonsCount }: LessonsGridHeaderProps) => {
  return (
    <div className="flex items-center gap-4 px-8">
      <Button
        variant="ghost"
        onClick={onBack}
        className="group hover:bg-gray-100 -ml-2"
      >
        <ArrowLeft className="h-5 w-5 mr-2 group-hover:-translate-x-1 transition-transform duration-200" />
        Back to Module
      </Button>
      {moduleDetails && (
        <div>
          <h1 className="text-2xl font-bold">{moduleDetails.title}</h1>
          <p className="text-gray-600">{lessonsCount} lessons available</p>
        </div>
      )}
    </div>
  );
};
